import { SvgType } from './types'

export default function Profile({ fill, style, size, viewBox }: SvgType) {
  return (
    <svg
      width={size}
      height={size}
      style={style}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fill}
        fillRule="evenodd"
        d="M7.832 12.266C6.554 11.189 5.75 9.624 5.75 7.882 5.75 4.634 8.548 2 12 2s6.25 2.634 6.25 5.882c0 1.742-.804 3.307-2.082 4.384C19.61 13.753 22 17.026 22 20.823c0 .65-.56 1.177-1.25 1.177s-1.25-.527-1.25-1.177c0-3.89-3.344-7.046-7.475-7.058h-.05c-4.13.012-7.475 3.168-7.475 7.058 0 .65-.56 1.177-1.25 1.177S2 21.473 2 20.823c0-3.797 2.39-7.07 5.832-8.557zm4.187-.854h-.039c-2.061-.01-3.73-1.586-3.73-3.53 0-1.949 1.679-3.53 3.75-3.53 2.071 0 3.75 1.581 3.75 3.53 0 1.944-1.669 3.52-3.73 3.53z"
        clipRule="evenodd"
      />
    </svg>
  )
}
